import type { GridRowClassNameParams } from "@mui/x-data-grid-pro"
import { gridClasses } from "@mui/x-data-grid-pro"
import { extraColors } from "../../utils/theme"
import type { BiothreatSignal } from "./AlertCurationContext"
import { DEFAULT_SCORE } from "./AlertCurationUtils"

export const sharedGridSx = {
  border: "none",
  padding: 0,
  backgroundColor: "transparent",
  [`& .${gridClasses.columnSeparator}`]: { display: "none" },
  [`& .${gridClasses.columnHeaders}`]: {
    borderBottom: `1px solid ${extraColors.translucent8}`,
    borderLeft: "3px solid transparent",
    mb: 0.5,
  },
  [`& .${gridClasses.columnHeader}`]: {
    padding: "0 8px",
  },
  [`& .${gridClasses.columnHeaderTitleContainer}`]: {
    padding: 0,
  },
  [`& .${gridClasses.cell}`]: {
    borderBottom: `1px solid ${extraColors.translucent5}`,
    padding: "0 8px",
  },
  [`& .${gridClasses.row}:last-of-type .${gridClasses.cell}`]: {
    borderBottom: `1px solid ${extraColors.translucent5}`,
  },
  [`& .${gridClasses.row}`]: {
    transition: "all 0.1s",
    minHeight: "58px",
    borderLeft: "3px solid transparent",
    "&:hover": {
      bgcolor: extraColors.translucent5,
    },
    "&.high-score": {
      borderLeftColor: extraColors.status.greenLight,
      bgcolor: "rgba(41, 209, 159, 0.01)",
    },
    "&.medium-score": {
      borderLeftColor: extraColors.translucent8,
    },
  },
  "& .MuiDataGrid-watermark": { display: "none" },
  [`& .${gridClasses.footerContainer}`]: { border: "none" },
}

export const getRowClassName = (
  params: GridRowClassNameParams<BiothreatSignal>
) => {
  const score = params.row.modern_score ?? DEFAULT_SCORE
  if (score > 0.9) return "high-score"
  if (score > 0.7) return "medium-score"
  return ""
}
